import React, { useState, useEffect, useRef } from "react";

import CCService from "../services/cc.service";
//import Table from 'react-bootstrap/Table'
import MUIDataTable from "mui-datatables";
import CCCard from "./CCCard";
import CardMobile from "./CardMobile";
import { useMediaQuery } from "react-responsive";
import { Modal, Button, Image } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap/";

import Lottie from "react-lottie";

import * as lapiz from "../assets/reloj.json";

import { EraserFill, FileEarmarkSpreadsheet } from "react-bootstrap-icons";
import { get } from "jquery";

const dayjs = require("dayjs");

const TablaCC = (tipo) => {
  const [content, setContent] = useState({ arts: [] });
  const [count, setCount] = useState({});
  const [elegido, setElegido] = useState(tipo.children);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });

  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const containerRef = useRef(null);
  const [auxTextSearch, setAuxTextSearch] = useState("");

  // Modal //
  const [tituloModal, setTituloModal] = useState("");
  const [rowGuardada, setRowGuardada] = useState("");
  // Fin Modal //

  // Modal Card//
  const [tituloModalCard, setTituloModalCard] = useState("Art");
  const [fullscreenCard, setFullscreenCard] = useState(true);
  const [showCard, setShowCard] = useState(false);
  const [dataArt, setDataArt] = useState();
  // Fin Modal Camara//

  const [loadingExcel, setLoadingExcel] = useState(undefined);
  const [loadingData, setLoadingData] = useState(false);

  const getData = () => {
    if (elegido === 0) {
      // Todos
      CCService.getTodos().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
    if (elegido === 1) {
      // Deudoras
      CCService.getDeudoras().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
    if (elegido === 2) {
      // Atrasadas
      CCService.getAtrasadas().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
  };
  useEffect(() => {
    if (navigator.geolocation) {
      console.log("Geolocalización disponible");
    } else {
      console.log("Geolocalización no disponible");
    }
    getData();
  }, []);

  const lapízOptions = {
    loop: true,
    autoplay: true,
    animationData: lapiz.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const columns = [
    {
      name: "idCuentaCorriente",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Codigo",
      label: "Codigo",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },
    {
      name: "cliente.RazonSocial",
      label: "Razón Social",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },
    {
      name: "cliente.Direccion",
      label: "Dirección",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },

    { name: "cliente.Cuit", label: "CUIT" },
    {
      name: "fechaUltimoPago",
      label: "Fecha Ultimo Pago",
      options: {
        display: false,
      },
    },
    {
      name: "saldo",
      label: "Saldo",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "diasAtrasado",
      label: "Dias Atrasado",
      options: {
        display: false,
      },
    },
    {
      name: "montoMaximo",
      label: "montoMaximo",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "clienteIdCliente",
      label: "clienteIdCliente",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Lat",
      label: "Lat",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Lng",
      label: "Lng",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.DiasDeVisita",
      label: "DiasDeVisita",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Alias",
      label: "Alias",
      options: {},
    },
  ];

  const options = {
    filterType: "checkbox",
    onRowsDelete: () => {
      return false;
    },
    sortOrder:
      elegido === 2
        ? {
            name: "diasAtrasado",
            direction: "desc",
          }
        : null,
    rowsPerPageOptions: 100,
    selectToolbarPlacement: "replace",
    responsive: "standard",
    searchOpen: true,
    searchAlwaysOpen: true,
    searchPlaceholder: "Buscar Cuentas Corrientes",
    filter: false,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    download: false,
    print: false,
    searchText: search,
    fixedHeader: true,
    fixedSelectColumn: true,
    enableNestedDataAccess: ".",
    onSearchClose: () => {
      console.log("Cierra");
    },
    isRowExpandable: (dataIndex, expandedRows) => {
      /*
    if(expandedRows.data.length>1){
      let original = expandedRows.data;
      let aux = expandedRows.data.slice(dataIndex,-1);
      expandedRows.data = aux;
      setMostradas(aux);
      return true;
    }
    else{
      
    }
    //expandedRows.data=[]; // Esto hace que siempre haya uno solo expandido
    return true;
    */
      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (
        expandedRows.data.length > 8 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    isRowSelectable: () => {
      return false;
    },
    selectableRows: false,
    rowsExpanded: [],
    onRowClick: (rowData) => {
      let i  = 0;
      /*
      if (isTabletOrMobile) {
        let textoSearch = containerRef.current.state.searchText;
        console.log(rowData);
        setTituloModal(rowData[2]);
        setRowGuardada(rowData);
        setAuxTextSearch(textoSearch);
        setShow(true);
      }
      */
    },
    /*
  renderExpandableRow: (rowData, rowMeta) => {
    if(!isTabletOrMobile){
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan} >
            <Card>{rowData}</Card>
          </TableCell>
        </TableRow>
      );
    }
  },
  */
    renderExpandableRow: (rowData, rowMeta) => {
      /*
      if (!isTabletOrMobile) {
        let textoSearch = containerRef.current.state.searchText;
        setRowGuardada(rowData);
        setAuxTextSearch(textoSearch);
        setDataArt(rowData);
        setTituloModalCard(rowData[2]);
        setShowCard(true);
      }
      */
      let textoSearch = containerRef.current.state.searchText;
      setRowGuardada(rowData);
      setAuxTextSearch(textoSearch);
      setDataArt(rowData);
      setTituloModalCard(rowData[2]);
      setShowCard(true);
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
      console.log(curExpanded, allExpanded, rowsExpanded);
    },
  };

  const actualizarPadre = (devuelto) => {
    setSearch(devuelto);
  };

  const cerrarModal = () => {
    setSearch(auxTextSearch);
    setShow(false);
  };
  const cerrarModalCard = () => {
    setSearch(auxTextSearch);
    setShowCard(false);
    getData();
  };
  const limpiarSearchBox = () => {
    //TODO Mejorar esto la segunda vez no lo borra
    //containerRef.current.state.searchText = "";
    setSearch("");
    setAuxTextSearch("");
  };

  if (content.message !== "Su usuario no se encuentra habilitado") {
    return (
      <Container fluid>
        {loadingExcel ? (
          <Lottie options={lapízOptions} height={200} width={200} />
        ) : (
          <div>
            <Row className="d-flex justify-content-center">
              <Col>
                {!loadingData ? (
                  <Lottie options={lapízOptions} height={200} width={200} />
                ) : (
                  <div>
                    {isTabletOrMobile && elegido === 0 ? (
                      <Row className="d-flex justify-content-center">
                        <Col>
                          <Button
                            variant="light"
                            onClick={() => limpiarSearchBox()}
                          >
                            <EraserFill size={30} /> Limpiar Campos
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      console.log("")
                    )}
                    <MUIDataTable
                      ref={containerRef}
                      title={"Lista de Cuentas Corrientes"}
                      data={content.arts}
                      columns={columns}
                      options={options}
                      id="tabla"
                    ></MUIDataTable>
                  </div>
                )}
              </Col>
            </Row>
            <Modal
              show={show}
              fullscreen={fullscreen}
              onHide={() => setShow(false)}
            >
              <Modal.Header>
                <Modal.Title>{tituloModal}</Modal.Title>
                <Button variant="outline-danger" onClick={() => cerrarModal()}>
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <CardMobile>{rowGuardada}</CardMobile>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-danger" onClick={() => cerrarModal()}>
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showCard}
              fullscreen={fullscreenCard}
              onHide={() => cerrarModalCard()}
            >
              <Modal.Header>
                <Modal.Title>{tituloModalCard}</Modal.Title>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalCard()}
                >
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <Col>
                    <CCCard>{dataArt}</CCCard>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalCard()}
                >
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </Container>
    );
  } else {
    return (
      <div className="container">
        <header className="jumbotron">
          {<h2> Su usuario no se encuentra habilitado</h2>}
        </header>
      </div>
    );
  }
};

export default TablaCC;
